import { formatToUSDate } from 'utils/dateTimeUtils/dateFormatUtil';
import getRelativeTimeParts from 'utils/getRelativeTimeParts';

import TileSubText from 'components/text/TileSubText';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const LastSynced: FunctionComponent<Props> = ({ className = '', syncedAt, testId = TEST_ID }) => {
    const { JUST_NOW, LAST_SYNCED, RELATIVE_DAYS, RELATIVE_HOURS, RELATIVE_MINUTES, SYNCED } =
        useTranslation();

    const { count, unit } = getRelativeTimeParts({ from: syncedAt, to: new Date() });

    const relativeLabelMap = {
        days: () => RELATIVE_DAYS({ count }),
        hours: () => RELATIVE_HOURS({ count }),
        minutes: () => RELATIVE_MINUTES({ count }),
        now: () => JUST_NOW
    };

    const staleClass = unit === 'days' ? styles.isStale : '';
    const text = `${SYNCED} ${relativeLabelMap[unit]()}`;
    const tooltip = LAST_SYNCED({ date: formatToUSDate(new Date(syncedAt)) });

    return (
        <TileSubText
            className={`${className} ${styles.lastSynced} ${staleClass}`}
            testId={testId}
            text={text}
            title={tooltip}
        />
    );
};

export default LastSynced;
